import { formatDutchDay } from "@/lib/formatDateTime";

/** Proposal due label. The date is a Madrid calendar day; the time is already Madrid wall clock. */
export function formatProposalDue(
  dueDate: string | null,
  dueTime: string | null,
  noDate: string,
): string {
  if (!dueDate) return noDate;
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dueDate);
  if (!match) return dueTime ? `${dueDate} om ${dueTime}` : dueDate;
  const day = formatDutchDay(
    new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3])),
  );
  return dueTime ? `${day} om ${dueTime}` : day;
}
